// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 38335 ? "auth-suite-store" : chunkId) + "-" + {"37311":"0d5abd77e936b77f6105","38335":"41217473677c28a2a106","80116":"be903ebdf9d181f3244f","90669":"8e87793688af6924d775"}[chunkId] + ".min.js";
};